module.exports = __webpack_public_path__ + "static/media/hospmang.6ecab087.png";